import { RootState } from "../../store";

export const selectCourse = (state: RootState) => state.course;